import { createFileRoute, getRouteApi, useRouter } from '@tanstack/react-router';
import { useMutation } from '@tanstack/react-query';
import { t } from '@lingui/core/macro';
import ConnectedAccounts from '@/components/Settings/ConnectedAccounts';
import { settingsService } from '@/services/settings';
import { useToast } from '@/hooks/useToast';

const settingsRoute = getRouteApi('/_app/settings');

export const Route = createFileRoute('/_app/settings/connected-accounts')({
  component: ConnectedAccountsPage,
});

function ConnectedAccountsPage() {
  const router = useRouter();
  const settings = settingsRoute.useLoaderData();
  const { showToast } = useToast();
  const formKey = settings.user.formKey;

  // Sharing preferences mutation
  const updateSharingPreferencesMutation = useMutation({
    mutationFn: ({
      service,
      type,
      value,
      formKey,
    }: {
      service: string;
      type: 'likes' | 'comments';
      value: boolean;
      formKey: string;
    }) => settingsService.updateSharingPreferences(service, type, value, formKey),
    onSuccess: async () => {
      showToast(t`Sharing preferences updated successfully`, 'success');
      await router.invalidate();
    },
    onError: (error) => {
      showToast(
        error instanceof Error
          ? error.message
          : t`Sorry, there was an error. Please try again.`,
        'error',
      );
    },
  });

  const handleToggleChange = (
    service: string,
    type: 'likes' | 'comments',
    checked: boolean,
  ) => {
    updateSharingPreferencesMutation.mutate({
      service,
      type,
      value: checked,
      formKey,
    });
  };

  return (
    <ConnectedAccounts
      connections={settings.connections}
      formKey={formKey}
      onToggleChange={handleToggleChange}
      isUpdating={updateSharingPreferencesMutation.isPending}
    />
  );
}
